import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import ConfigData from '../../config.json';

const GridRoomType = ({data, roomTypeId, onClickSelect}) => {
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        setGridData(data);
    }, [data]);

    return (
        <React.Fragment>
            <Row className="room-type-list">
                {(gridData.length > 0) ? gridData.map((item, key) => (
                    <Col sm={12} md={4} lg={4} className="room-type-detail" key={"room-type-" + key}>
                        <Card className={(roomTypeId === item.id) ? "room-type-card-select" : "room-type-card"} onClick={(e) => { onClickSelect(item); }}>
                            <CardBody>
                                <Row>
                                    <Col lg={12}>
                                        <div className="text-center">
                                            <img src={ConfigData.IMAGE_ROOM_URL + item.room_pic} alt="" className="room-type-img" />
                                        </div>
                                        <p className={"mb-2 mt-3 " + ((roomTypeId === item.id) ? "room-type-name-select" : "room-type-name")}>{item.name}</p>
                                        <p className={"mb-1 " + ((roomTypeId === item.id) ? "room-type-location-select" : "room-type-location")}>
                                            <i className={"ri-map-pin-2-fill " + ((roomTypeId === item.id) ? "room-type-icon-select" : "room-type-icon")}></i>&nbsp;&nbsp;
                                            {item.location}
                                        </p>
                                        <p className={"mb-1 " + ((roomTypeId === item.id) ? "room-type-size-select" : "room-type-size")}>
                                            <i className={"ri-user-fill " + ((roomTypeId === item.id) ? "room-type-icon-select" : "room-type-icon")}></i>&nbsp;&nbsp;
                                            {item.room_size}&nbsp;Seat
                                        </p>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                )) : (
                    <Col lg={12} className="room-type-detail" style={{width: "100%"}}>
                        <Card>
                            <CardBody>
                                <Row className="align-item-center">
                                    <Col lg={12} className="text-center">
                                        <h4 className="my-4">No Result Found!</h4>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                )}
            </Row>
        </React.Fragment>
    );
};

export default GridRoomType;